<script>
  import service from '../../../../domain/leiloes/services'
  export default{
    name: 'select-modelo',
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        id: null,
        loadError: false,
        isLoading: false,
        modelos: null
      }
    },
    computed: {
      model: {
        get () {
          return this.value === null ? '' : this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      load (id) {
        this.id = id
        this.isLoading = true
        service.buscaModelos(id).then((response) => {
          this.isLoading = false
          this.modelos = response.data.modelos
        })
          .catch((response) => {
            this.isLoading = false
            window.responseError(response)
            console.log(response)
          })
      }
    },
    components: {}
  }
</script>

<template>
  <div class="form-group">
    <label class="col-lg-2 control-label">Modelo</label>
    <div class="col-lg-10">
      <select :disabled="id === null" v-model="model" class="form-control w-auto w-full-xs">
        <option disabled value="">{{ id !== null ? (isLoading ? 'Carregando' : 'Selecione') : 'Selecione o modelo primeiro' }}</option>
        <option v-for="modelo in modelos" :value="modelo.id" :key="modelo.id">{{ modelo.nome }}</option>
      </select>
      <a v-if="loadError" class="btn text-danger" @click="load">Não foi possível carregar. Tente novamente</a>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// SelectModelo.vue?4936a51c